module.exports = __webpack_public_path__ + "908e4d2e/img/upload-icon.9179ae4e.svg";